import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';

// svgs
import externalLinkSVG from '../../../inlineSVGs/externalLinkSVG';
import coinSVG from '../../../inlineSVGs/coinSVG';

// styles
import './ButtonTickets.css';

const ButtonTickets = ({ prices, label, link, wrapperStyle, isDisabled }) => {
    const getPrices = () => {
        let pricesStr = 'חינם';
        let currency = '';

        if (prices.priceType === 'hat') {
            pricesStr = 'כובע';
        }

        if (prices.min && prices.max) {
            pricesStr = `${prices.min} - ${prices.max}`;
            currency = prices.currency;
        }

        if (prices.price) {
            pricesStr = prices.price;
            currency = prices.currency;
        }

        return <p className="text">{pricesStr} <label>{currency}</label></p>
    };

    const handleTicketClick = () => {
        window.open(link, '_blank');
    };

    if (!link && !prices) return null;

    return (
        <div className="button-wrapper rtl" style={wrapperStyle}>
            {prices
                ?
                <div className="prices">
                    <SVGInline className="coin-icon" svg={coinSVG} component="i"/>
                    {getPrices()}
                </div>
                :  null
            }
            {link && prices
                ?
                <button disabled={isDisabled} onClick={() => handleTicketClick()}>
                    {label}
                    <SVGInline className="external-link-icon" svg={externalLinkSVG} component="i"/>
                </button>
                : null
            }
        </div>
    )
};

ButtonTickets.propTypes = {
    onPress: PropTypes.func,
    prices: PropTypes.object,
    label: PropTypes.string,
    link: PropTypes.string,
    wrapperStyle: PropTypes.object,
    isDisabled: PropTypes.bool
};

export default ButtonTickets;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/ButtonTickets/ButtonTickets.js